export default class ColorState {
  name = String;
  hex = String;

  /* this is used for display position */
  index = Number;
}
